import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import OnboardingContainer from '../Component/OnboardingContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { ScreenBackV2WithTitle } from '../../Components/ScreenBackV2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RegisterV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const forwarded_phone_number = location?.state?.phone_number || null;
  const [phoneNumber, setPhoneNumber] = useState(forwarded_phone_number);

  const handleOnClickLogin = () => {
    navigate('/login');
  };
  const onFinish = async () => {
    if (!phoneNumber) return toast.error('Phone number is required');

    if (phoneNumber.length < 10)
      return toast.error('Enter a valid mobile number');

    navigate('/VerifyUserForRegister', {
      state: { phone_number: phoneNumber },
    });
  };
  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title='Register' />
      <Stack
        spacing={1}
        direction={'row'}
        alignItems={'center'}
        alignContent={'center'}
      >
        <Typography
          variant='subtitle2'
          gutterBottom
          color={'white'}
          fontSize={'1rem'}
        >
          Already have an account ?{'  '}
        </Typography>
        <Button
          variant='text'
          onClick={handleOnClickLogin}
        >
          {' '}
          Login
        </Button>
      </Stack>

      <Stack
        sx={{ mt: '2rem', width: '80%' }}
        direction={'column'}
        spacing={2}
      >
        <TextField
          className='darkBackground'
          margin='normal'
          required
          fullWidth
          id='phoneNumber'
          label='Phone Number'
          name='phoneNumber'
          autoComplete='phoneNumber'
          autoFocus
          color='secondary'
          value={phoneNumber}
          onChange={(e) => {
            if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10)
              setPhoneNumber(e.target.value);
          }}
        />

        <Button
          variant='contained'
          color='primary'
          sx={{ width: '100%' }}
          onClick={onFinish}
        >
          Verify Your Number
        </Button>
      </Stack>
    </OnboardingContainer>
  );
};

export default RegisterV2;
